import { BtnColorType, gridSizeConst10, gridSizeConst2, gridSizeMdLg12 } from '@/shared/constants';
import { Close } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { ReactNode } from 'react';

export interface ScrollableDialogPropsProps {
  open: boolean;
  title: string;
  contentText?: string;
  contentNode?: React.ReactNode;
  cancelTextBtn?: string;
  cancelVariantBtn?: 'text' | 'outlined' | 'contained';
  confirmTextBtn?: string | ReactNode;
  confirmVariantBtn?: 'text' | 'outlined' | 'contained';
  titleIcon?: React.ReactNode

  showConfirmBtn?: boolean;
  onConfirm?: (() => Promise<void>) | (() => void);
  onClose?: () => void;
  onCloseIcon?: () => void;

  showCustomButtons?: boolean;
  customButtons?: React.ReactNode;

  width?: string;
  minWidth?: string;
  minHeight?: string;
  dialogContentText?: string;

  confirmBtnColor?: BtnColorType;
  cancelBtnColor?: BtnColorType;

  // Nuevas propiedades para el botón de rechazo
  rejectTextBtn?: string;
  rejectVariantBtn?: 'text' | 'outlined' | 'contained';
  rejectBtnColor?: BtnColorType;
  onReject?: () => void;
  showRejectBtn?: boolean;

  dividers?: boolean;

  // Deshabilitar botón de confirmación
  confirmDisabled?: boolean;

  ///Segundo boton de confirmar
  secondaryConfirmTextBtn?: string | ReactNode;
  secondaryConfirmVariantBtn?: 'text' | 'outlined' | 'contained';
  secondaryConfirmBtnColor?: BtnColorType;
  onSecondaryConfirm?: () => void;
  showSecondaryConfirmBtn?: boolean;
  isCloseIcon?: boolean
}

const ScrollableDialogProps: React.FC<ScrollableDialogPropsProps> = ({
  open,
  title,
  titleIcon
  , cancelTextBtn = 'Cancelar',
  cancelVariantBtn = 'text',
  confirmTextBtn = 'Confirmar',
  confirmVariantBtn = 'text',
  contentNode,
  contentText,
  onClose,
  onConfirm,
  showConfirmBtn = true,

  showCustomButtons = false,
  customButtons,
  minWidth = '45%',
  width = '100%',
  minHeight = '35%',
  dialogContentText = '',

  confirmBtnColor = 'primary',
  cancelBtnColor = 'inherit',

  // Valores predeterminados para las nuevas propiedades
  rejectTextBtn = 'Rechazar',
  rejectVariantBtn = 'text',
  rejectBtnColor = 'primary',
  onReject,
  onCloseIcon,
  showRejectBtn = false,
  dividers = true,

  // Deshabilitar botón de confirmación
  confirmDisabled = false,

  /// prodpiedades para el segundo bonton de confirmar
  secondaryConfirmTextBtn = "ConfirSecondary",
  secondaryConfirmVariantBtn = 'outlined',
  secondaryConfirmBtnColor = "secondary",
  onSecondaryConfirm,
  showSecondaryConfirmBtn = false,
  isCloseIcon = true
}) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={() => {
          onClose && onClose()
          isCloseIcon && onCloseIcon && onCloseIcon()
        }}
        scroll="paper"
        sx={{ '& .MuiDialog-paper': { width, minWidth, minHeight } }}
      >
        <Grid
          {...gridSizeMdLg12}
          container
          item
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Grid container item {...gridSizeConst10}>
            <DialogTitle id="scroll-dialog-title">
              {/* {title} */}
              <Box display="flex" alignItems="center" gap={1}>
                {titleIcon && (
                  <Box display="flex" alignItems="center">
                    {titleIcon}
                  </Box>
                )}
                <Typography variant="inherit">
                  {title}
                </Typography>
              </Box>
            </DialogTitle>
          </Grid>
          <Grid container item {...gridSizeConst2} justifyContent={"end"} alignItems={"end"} alignContent={"end"}>
            {onCloseIcon && (
              <Tooltip title='Cerrar'>
                <IconButton onClick={onCloseIcon}>
                  <Close />
                </IconButton>
              </Tooltip>
            )}
          </Grid>
          {dialogContentText && (
            <Grid container item {...gridSizeMdLg12} padding={'0px 20px'}>
              <Typography variant="inherit"
                sx={{ color: '#6C737F' }}>
                {dialogContentText}
              </Typography>
            </Grid>
          )}

        </Grid>


        <DialogContent dividers={dividers}>
          {contentNode ? (
            contentNode
          ) : (
            <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
              {contentText}
            </DialogContentText>
          )}
        </DialogContent>

        {showCustomButtons && !!customButtons ? (
          <DialogActions>{customButtons}</DialogActions>
        ) : (
          <DialogActions>

            <Grid container spacing={2} justifyContent={'space-between'}>
              <Grid item>

                {!!onClose && (
                  <Button
                    onClick={onClose}
                    variant={cancelVariantBtn}
                    color={cancelBtnColor}
                  >
                    {cancelTextBtn}
                  </Button>
                )}


              </Grid>

              <Grid item>
                {/* Botón de rechazo opcional */}
                {!!onReject && !!showRejectBtn && (
                  <Button
                    onClick={onReject}
                    variant={rejectVariantBtn}
                    color={rejectBtnColor}
                    sx={{ marginRight: '10px' }}
                  >
                    {rejectTextBtn}
                  </Button>
                )}
                {!!onConfirm && !!showConfirmBtn && (
                  <Button
                    onClick={onConfirm}
                    disabled={confirmDisabled}
                    variant={confirmVariantBtn}
                    color={confirmBtnColor}
                  >
                    {confirmTextBtn}
                  </Button>
                )}
                {!!onSecondaryConfirm && !!showSecondaryConfirmBtn && (
                  <Button
                    onClick={onSecondaryConfirm}
                    variant={secondaryConfirmVariantBtn}
                    color={secondaryConfirmBtnColor}
                    sx={{ marginLeft: '8px', marginRight: '8px' }}
                  >
                    {secondaryConfirmTextBtn}
                  </Button>
                )}
              </Grid>
            </Grid>
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};

export default ScrollableDialogProps;
